var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessengerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.009,
    height: 19.999,
    viewBox: "0 0 17.009 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M53.117,557.875a.649.649,0,0,1-.272-.528V554.93A8.479,8.479,0,1,1,62,546.477a12.109,12.109,0,0,1-8.3,11.488.653.653,0,0,1-.59-.09Zm1.037-13.136v2.608a.654.654,0,0,0,.654.652H56.76a1.694,1.694,0,0,1-.936,1.373.652.652,0,1,0,.585,1.166,3,3,0,0,0,1.67-2.694v-3.107a.651.651,0,0,0-.38-.592v.8H56.62v-.863H54.808A.653.653,0,0,0,54.154,544.739Zm-5.233,0v2.608a.654.654,0,0,0,.654.652h1.952a1.7,1.7,0,0,1-.936,1.373.652.652,0,1,0,.585,1.166,3,3,0,0,0,1.67-2.694v-2.9H52.31V544.1a.664.664,0,0,0-.118-.011H49.575A.653.653,0,0,0,48.92,544.739Z",
    transform: "translate(-44.996 -537.999)",
    fill: "#aaa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIcon);
export default __webpack_public_path__ + "static/media/messenger-icon.053b15a4.svg";
export { ForwardRef as ReactComponent };